import { IComponentOptions, IController } from "angular";
import { IMetric } from "@gtmhub/okrs/metrics";
import { IPlanningSession } from "@gtmhub/sessions";

export class MetricBarProgressComponentCtrl implements IController {
  metric: IMetric;
  planningSession: IPlanningSession;
}

export const MetricBarProgressComponent: IComponentOptions = {
  templateUrl: require("./metric-bar-progress.jade"),
  controller: MetricBarProgressComponentCtrl,
  bindings: {
    metric: "<",
    planningSession: "<",
  },
};
